import React, { createContext, useState, useEffect } from 'react';
import { login, verifyToken } from '../services/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token') || null);

  const handleLogin = async (credentials) => {
    const response = await login(credentials);
    setToken(response.data.token);
    localStorage.setItem('token', response.data.token);
  };

  const verifyUser = async () => {
    if (token) {
      try {
        const response = await verifyToken(token);
        setUser(response.data);
      } catch {
        setToken(null);
        localStorage.removeItem('token');
      }
    }
  };

  useEffect(() => {
    verifyUser();
  }, [token]);

  return (
    <AuthContext.Provider value={{ user, token, handleLogin }}>
      {children}
    </AuthContext.Provider>
  );
};
